import { render, staticRenderFns } from "./judging.page.vue?vue&type=template&id=41b2ddee&scoped=true&"
import script from "./judging.page.vue?vue&type=script&lang=js&"
export * from "./judging.page.vue?vue&type=script&lang=js&"
import style0 from "./judging.page.vue?vue&type=style&index=0&id=41b2ddee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b2ddee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
